module.exports = __webpack_public_path__ + "static/img/10.0b46145.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/16/zh/10.png
// module id = DJbM
// module chunks = 0